import error from '@images/error.jpg';
import loading from '@images/loading.gif';
import Vue from 'vue';
import VueLazy from 'vue-lazyload';

// const isDebug = process.env.NODE_ENV !== 'production';

Vue.use(VueLazy, {
    preLoad: 1.3,
    error: error,
    loading: loading,
    attempt: 1,
    // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
    listenEvents: ['scroll'],
    filter: {
        // progressive(listener) {
        //     const isLocal = /^\/img/;
        //     if (isDebug || isLocal.test(listener.src)) {
        //         listener.el.setAttribute('lazy-progressive', 'true');
        //         listener.loading = listener.src.replace(/\.(\w+?)(\?[\s\S]+)?$/, '.min.$1$2');
        //     }
        // }
        // webp(listener, options) {
        //     if (isDebug || !options.supportWebp) return;
        //     listener.src = listener.src.replace(/\.(svg|png|jpe?g|bmp|gif)$/, '.webp');
        // }
    }
});
